
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class AutocompleteMultipleWTooltip extends Vue {
  private onInputUpdate(val: any) {
    this.$emit('input', val)
  }
}
